export function convertKopecksToFen(kopecks: number, rubPerYuan: number): number {
  if (rubPerYuan <= 0) throw new Error("rubPerYuan must be > 0");
  return Math.round(kopecks / rubPerYuan);
}

export function convertFenToKopecks(fen: number, rubPerYuan: number): number {
  if (rubPerYuan <= 0) throw new Error("rubPerYuan must be > 0");
  return Math.round(fen * rubPerYuan);
}
